export default __webpack_public_path__ + "static/media/sorry_cat.d4799829.jpg";